import Vue from 'vue';
import App from './index.vue'

new Vue(App).$mount('#app');
